import { Navigate } from 'react-router-dom';

import { useAuth } from 'src/contexts/AuthContext';

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

export default function ProtectedRoute({ children }: Props) {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/dang-nhap" replace />;
  }

  return <>{children}</>;
}
